// extracted by mini-css-extract-plugin
module.exports = {"productWrapper":"XNLUe","vScroll":"f5f92","listItem":"JDTC2","title":"AUdBv","viewAll":"VZoTQ"};